import { connect, ConnectedProps } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router';
import { RootState } from '../../../../store/root-reducer';
import {
  hideError,
  loginRequest,
  setIsRedirectedFromAgency,
} from '../login/login-slice';
import AgencyClientLogin from './agency-client-login';

const mapStateToProps = (state: RootState) => ({
  loginRequestStatus: state.login.loginRequest.status,
  loginRequestMessage: state.login.loginRequest.message,
  loginRequestError: state.login.loginRequest.error,
  loginRequestShowError: state.login.loginRequest.showError,

  token: state.login.token,

  trackingId: state.login.trackingId,
  firstName: state.login.firstName,
  lastName: state.login.lastName,
  email: state.login.email,
  mfaChannel: state.login.mfaChannel,

  agencyConfig: state.home.agencyConfig,
  agencyConfigRequestStatus: state.home?.getAgencyConfigRequest.status,
  companyName: state.home.agencyConfig?.companyName,
  clientLogo: state.home.agencyConfig?.clientLogo,
});

const mapDispatchToProps = {
  hideError: () => hideError(),
  sendLoginRequest: (email: string, password: string) =>
    loginRequest({ email, password }),
  setIsRedirectedFromAgency: (value: boolean) =>
    setIsRedirectedFromAgency(value),
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type IProps = ConnectedProps<typeof connector> & RouteComponentProps;

export default withRouter(connector(AgencyClientLogin));
